import React from 'react';
import styles from './style.module.scss';
import classNames from 'classnames';
import { statusEnum } from './Constant';
export default function Status({ status, statusContainer }) {
    return (
        <div
            className={classNames(
                styles.Status,
                statusContainer && statusContainer,
                statusEnum.inprogress === status
                    ? styles.Inprogress
                    : statusEnum.stucked === status
                    ? styles.Stucked
                    : statusEnum.pending === status
                    ? styles.Pending
                    : statusEnum.pipeline === status
                    ? styles.Pipeline
                    : statusEnum.complete === status
                    ? styles.Complete
                    : statusEnum.active === status
                    ? styles.Active
                    : statusEnum.deactive === status || statusEnum.inActive === status
                    ? styles.Deactive
                    : styles.Inprogress
            )}
        >
            {status}
        </div>
    );
}
